import { useState } from 'react';

const useCopy = () => {
  const [copied, setCopied] = useState(false);
  const [copyError, setCopyError] = useState(false);
  const onCopy = async (value: string, delay: number = 1000) => {
    try {
      await navigator.clipboard.writeText(value); // some devices can't copy, thats why returning if error occurs
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, delay);
    } catch (e) {
      setCopyError(true);
      setTimeout(() => {
        setCopyError(false);
      }, 3000);
    }
  };

  return {
    copied,
    copyError,
    onCopy,
  };
};

export default useCopy;
